<template>
  <main class="container">
    <div class="row contact-us-box">
      <h2 class="col-12">
        {{ $t("Please12") }}{{ $t("Submit12") }}{{ $t("Your12")
        }}{{ $t("Needs12") }}
      </h2>
      <form
        id="contact_form"
        name="contact_form"
        class="col-12 col-md-11 col-x1-6"
        ref="form"
        @submit.prevent="sendEmail"
      >
        <div class="problem-box">
          <hr class="hr-text" data-content="Your Needs" />
          <div class="custom-checkbox-conatiner">
            <span data-tip="Please select at least one item">
              ::before ::after
            </span>
            <div class="custom-control custom-checkbox">
              <input
                class="custom-control-input"
                id="choice-need-1"
                type="checkbox"
                value="Machinery"
                v-model="Machinery"
                name="Machinery"
              />
              <label class="custom-control-label" for="choice-need-1">
                <font style="vertical-align: inherit">
                  {{ $t("machinery12") }}
                </font>
              </label>
            </div>
          </div>
        </div>
        <hr class="hr-text" data-content="Please Enter Contact Information" />
        <div class="contact-info form-group">
          <div>
            <input
              id="companyName"
              type="text"
              class="form-control required-text"
              :placeholder="$t('ComName12')"
              v-model="companyName"
              name="companyName"
              required
            />
          </div>
          <div>
            <input
              id="email"
              type="email"
              class="form-control"
              :placeholder="$t('E-maillAddr12')"
              v-model="email"
              name="email"
              required
            />
          </div>
          <div>
            <input
              id="person"
              type="text"
              class="form-control required-text"
              :placeholder="$t('ContactPerson12')"
              v-model="Name"
              name="Name"
              required
            />
          </div>
          <div class="problem-radio-box">
            <span data-tip="Please select your gender"></span>
            <p class="mb-0 mt-1 ml-2 mr-3">{{ $t("Gender12") }} :</p>
            <div class="custom-control custom-radio inquire-category">
              <input
                v-model="inquiryCategory"
                name="inquiryCategory"
                class="custom-control-input"
                id="inquiry-category-1"
                type="radio"
                value="Mr"
                required
              />
              <label class="custom-control-label" for="inquiry-category-1">
                {{ $t("Mr12") }}
              </label>
            </div>
            <div class="custom-control custom-radio inquire-category">
              <input
                v-model="inquiryCategory"
                name="inquiryCategory"
                class="custom-control-input"
                id="inquiry-category-2"
                type="radio"
                value="Miss"
              />
              <label class="custom-control-label" for="inquiry-category-2">
                {{ $t("Miss12") }}
              </label>
            </div>
          </div>
          <div class="select-box">
            <select
              id="country"
              data-placeholder="*Your Country"
              class="form-control"
              v-model="country"
              name="country"
              required
            >
              <option selected style="display: inline">
                {{ $t("PleaseSelect12") }}
              </option>
              <option data-countrycode="DZ" value="213">Algeria (+213)</option>
              <option data-countrycode="AD" value="376">Andorra (+376)</option>
              <option data-countrycode="AO" value="244">Angola (+244)</option>
              <option data-countrycode="AI" value="1264">
                Anguilla (+1264)
              </option>
              <option data-countrycode="AG" value="1268">
                Antigua & Barbuda (+1268)
              </option>
              <option data-countrycode="AR" value="54">Argentina (+54)</option>
              <option data-countrycode="AM" value="374">Armenia (+374)</option>
              <option data-countrycode="AW" value="297">Aruba (+297)</option>
              <option data-countrycode="AU" value="61">Australia (+61)</option>
              <option data-countrycode="AT" value="43">Austria (+43)</option>
              <option data-countrycode="AZ" value="994">
                Azerbaijan (+994)
              </option>
              <option data-countrycode="BS" value="1242">
                Bahamas (+1242)
              </option>
              <option data-countrycode="BH" value="973">Bahrain (+973)</option>
              <option data-countrycode="BD" value="880">
                Bangladesh (+880)
              </option>
              <option data-countrycode="BB" value="1246">
                Barbados (+1246)
              </option>
              <option data-countrycode="BY" value="375">Belarus (+375)</option>
              <option data-countrycode="BE" value="32">Belgium (+32)</option>
              <option data-countrycode="BZ" value="501">Belize (+501)</option>
              <option data-countrycode="BJ" value="229">Benin (+229)</option>
              <option data-countrycode="BM" value="1441">
                Bermuda (+1441)
              </option>
              <option data-countrycode="BT" value="975">Bhutan (+975)</option>
              <option data-countrycode="BO" value="591">Bolivia (+591)</option>
              <option data-countrycode="BA" value="387">
                Bosnia Herzegovina (+387)
              </option>
              <option data-countrycode="BW" value="267">Botswana (+267)</option>
              <option data-countrycode="BR" value="55">Brazil (+55)</option>
              <option data-countrycode="BN" value="673">Brunei (+673)</option>
              <option data-countrycode="BG" value="359">Bulgaria (+359)</option>
              <option data-countrycode="BF" value="226">
                Burkina Faso (+226)
              </option>
              <option data-countrycode="BI" value="257">Burundi (+257)</option>
              <option data-countrycode="KH" value="855">Cambodia (+855)</option>
              <option data-countrycode="CM" value="237">Cameroon (+237)</option>
              <option data-countrycode="CA" value="1">Canada (+1)</option>
              <option data-countrycode="CV" value="238">
                Cape Verde Islands (+238)
              </option>
              <option data-countrycode="KY" value="1345">
                Cayman Islands (+1345)
              </option>
              <option data-countrycode="CF" value="236">
                Central African Republic (+236)
              </option>
              <option data-countrycode="CL" value="56">Chile (+56)</option>
              <option data-countrycode="CN" value="86">China (+86)</option>
              <option data-countrycode="CO" value="57">Colombia (+57)</option>
              <option data-countrycode="KM" value="269">Comoros (+269)</option>
              <option data-countrycode="CG" value="242">Congo (+242)</option>
              <option data-countrycode="CK" value="682">
                Cook Islands (+682)
              </option>
              <option data-countrycode="CR" value="506">
                Costa Rica (+506)
              </option>
              <option data-countrycode="HR" value="385">Croatia (+385)</option>
              <option data-countrycode="CU" value="53">Cuba (+53)</option>
              <option data-countrycode="CY" value="90392">
                Cyprus North (+90392)
              </option>
              <option data-countrycode="CY" value="357">
                Cyprus South (+357)
              </option>
              <option data-countrycode="CZ" value="42">
                Czech Republic (+42)
              </option>
              <option data-countrycode="DK" value="45">Denmark (+45)</option>
              <option data-countrycode="DJ" value="253">Djibouti (+253)</option>
              <option data-countrycode="DM" value="1809">
                Dominica (+1809)
              </option>
              <option data-countrycode="DO" value="1809">
                Dominican Republic (+1809)
              </option>
              <option data-countrycode="EC" value="593">Ecuador (+593)</option>
              <option data-countrycode="EG" value="20">Egypt (+20)</option>
              <option data-countrycode="SV" value="503">
                El Salvador (+503)
              </option>
              <option data-countrycode="GQ" value="240">
                Equatorial Guinea (+240)
              </option>
              <option data-countrycode="ER" value="291">Eritrea (+291)</option>
              <option data-countrycode="EE" value="372">Estonia (+372)</option>
              <option data-countrycode="ET" value="251">Ethiopia (+251)</option>
              <option data-countrycode="FK" value="500">
                Falkland Islands (+500)
              </option>
              <option data-countrycode="FO" value="298">
                Faroe Islands (+298)
              </option>
              <option data-countrycode="FJ" value="679">Fiji (+679)</option>
              <option data-countrycode="FI" value="358">Finland (+358)</option>
              <option data-countrycode="FR" value="33">France (+33)</option>
              <option data-countrycode="GF" value="594">
                French Guiana (+594)
              </option>
              <option data-countrycode="PF" value="689">
                French Polynesia (+689)
              </option>
              <option data-countrycode="GA" value="241">Gabon (+241)</option>
              <option data-countrycode="GM" value="220">Gambia (+220)</option>
              <option data-countrycode="GE" value="7880">
                Georgia (+7880)
              </option>
              <option data-countrycode="DE" value="49">Germany (+49)</option>
              <option data-countrycode="GH" value="233">Ghana (+233)</option>
              <option data-countrycode="GI" value="350">
                Gibraltar (+350)
              </option>
              <option data-countrycode="GR" value="30">Greece (+30)</option>
              <option data-countrycode="GL" value="299">
                Greenland (+299)
              </option>
              <option data-countrycode="GD" value="1473">
                Grenada (+1473)
              </option>
              <option data-countrycode="GP" value="590">
                Guadeloupe (+590)
              </option>
              <option data-countrycode="GU" value="671">Guam (+671)</option>
              <option data-countrycode="GT" value="502">
                Guatemala (+502)
              </option>
              <option data-countrycode="GN" value="224">Guinea (+224)</option>
              <option data-countrycode="GW" value="245">
                Guinea - Bissau (+245)
              </option>
              <option data-countrycode="GY" value="592">Guyana (+592)</option>
              <option data-countrycode="HT" value="509">Haiti (+509)</option>
              <option data-countrycode="HN" value="504">Honduras (+504)</option>
              <option data-countrycode="HK" value="852">
                Hong Kong (+852)
              </option>
              <option data-countrycode="HU" value="36">Hungary (+36)</option>
              <option data-countrycode="IS" value="354">Iceland (+354)</option>
              <option data-countrycode="IN" value="91">India (+91)</option>
              <option data-countrycode="ID" value="62">Indonesia (+62)</option>
              <option data-countrycode="IR" value="98">Iran (+98)</option>
              <option data-countrycode="IQ" value="964">Iraq (+964)</option>
              <option data-countrycode="IE" value="353">Ireland (+353)</option>
              <option data-countrycode="IL" value="972">Israel (+972)</option>
              <option data-countrycode="IT" value="39">Italy (+39)</option>
              <option data-countrycode="JM" value="1876">
                Jamaica (+1876)
              </option>
              <option data-countrycode="JP" value="81">Japan (+81)</option>
              <option data-countrycode="JO" value="962">Jordan (+962)</option>
              <option data-countrycode="KZ" value="7">Kazakhstan (+7)</option>
              <option data-countrycode="KE" value="254">Kenya (+254)</option>
              <option data-countrycode="KI" value="686">Kiribati (+686)</option>
              <option data-countrycode="KP" value="850">
                Korea North (+850)
              </option>
              <option data-countrycode="KR" value="82">
                Korea South (+82)
              </option>
              <option data-countrycode="KW" value="965">Kuwait (+965)</option>
              <option data-countrycode="KG" value="996">
                Kyrgyzstan (+996)
              </option>
              <option data-countrycode="LA" value="856">Laos (+856)</option>
              <option data-countrycode="LV" value="371">Latvia (+371)</option>
              <option data-countrycode="LB" value="961">Lebanon (+961)</option>
              <option data-countrycode="LS" value="266">Lesotho (+266)</option>
              <option data-countrycode="LR" value="231">Liberia (+231)</option>
              <option data-countrycode="LY" value="218">Libya (+218)</option>
              <option data-countrycode="LI" value="417">
                Liechtenstein (+417)
              </option>
              <option data-countrycode="LT" value="370">
                Lithuania (+370)
              </option>
              <option data-countrycode="LU" value="352">
                Luxembourg (+352)
              </option>
              <option data-countrycode="MO" value="853">Macao (+853)</option>
              <option data-countrycode="MK" value="389">
                Macedonia (+389)
              </option>
              <option data-countrycode="MG" value="261">
                Madagascar (+261)
              </option>
              <option data-countrycode="MW" value="265">Malawi (+265)</option>
              <option data-countrycode="MY" value="60">Malaysia (+60)</option>
              <option data-countrycode="MV" value="960">Maldives (+960)</option>
              <option data-countrycode="ML" value="223">Mali (+223)</option>
              <option data-countrycode="MT" value="356">Malta (+356)</option>
              <option data-countrycode="MH" value="692">
                Marshall Islands (+692)
              </option>
              <option data-countrycode="MQ" value="596">
                Martinique (+596)
              </option>
              <option data-countrycode="MR" value="222">
                Mauritania (+222)
              </option>
              <option data-countrycode="YT" value="269">Mayotte (+269)</option>
              <option data-countrycode="MX" value="52">Mexico (+52)</option>
              <option data-countrycode="FM" value="691">
                Micronesia (+691)
              </option>
              <option data-countrycode="MD" value="373">Moldova (+373)</option>
              <option data-countrycode="MC" value="377">Monaco (+377)</option>
              <option data-countrycode="MN" value="976">Mongolia (+976)</option>
              <option data-countrycode="MS" value="1664">
                Montserrat (+1664)
              </option>
              <option data-countrycode="MA" value="212">Morocco (+212)</option>
              <option data-countrycode="MZ" value="258">
                Mozambique (+258)
              </option>
              <option data-countrycode="MN" value="95">Myanmar (+95)</option>
              <option data-countrycode="NA" value="264">Namibia (+264)</option>
              <option data-countrycode="NR" value="674">Nauru (+674)</option>
              <option data-countrycode="NP" value="977">Nepal (+977)</option>
              <option data-countrycode="NL" value="31">
                Netherlands (+31)
              </option>
              <option data-countrycode="NC" value="687">
                New Caledonia (+687)
              </option>
              <option data-countrycode="NZ" value="64">
                New Zealand (+64)
              </option>
              <option data-countrycode="NI" value="505">
                Nicaragua (+505)
              </option>
              <option data-countrycode="NE" value="227">Niger (+227)</option>
              <option data-countrycode="NG" value="234">Nigeria (+234)</option>
              <option data-countrycode="NU" value="683">Niue (+683)</option>
              <option data-countrycode="NF" value="672">
                Norfolk Islands (+672)
              </option>
              <option data-countrycode="NP" value="670">
                Northern Marianas (+670)
              </option>
              <option data-countrycode="NO" value="47">Norway (+47)</option>
              <option data-countrycode="OM" value="968">Oman (+968)</option>
              <option data-countrycode="PK" value="92">Pakistan (+92)</option>
              <option data-countrycode="PW" value="680">Palau (+680)</option>
              <option data-countrycode="PA" value="507">Panama (+507)</option>
              <option data-countrycode="PG" value="675">
                Papua New Guinea (+675)
              </option>
              <option data-countrycode="PY" value="595">Paraguay (+595)</option>
              <option data-countrycode="PE" value="51">Peru (+51)</option>
              <option data-countrycode="PH" value="63">
                Philippines (+63)
              </option>
              <option data-countrycode="PL" value="48">Poland (+48)</option>
              <option data-countrycode="PT" value="351">Portugal (+351)</option>
              <option data-countrycode="PR" value="1787">
                Puerto Rico (+1787)
              </option>
              <option data-countrycode="QA" value="974">Qatar (+974)</option>
              <option data-countrycode="RE" value="262">Reunion (+262)</option>
              <option data-countrycode="RO" value="40">Romania (+40)</option>
              <option data-countrycode="RU" value="7">Russia (+7)</option>
              <option data-countrycode="RW" value="250">Rwanda (+250)</option>
              <option data-countrycode="SM" value="378">
                San Marino (+378)
              </option>
              <option data-countrycode="ST" value="239">
                Sao Tome & Principe (+239)
              </option>
              <option data-countrycode="SA" value="966">
                Saudi Arabia (+966)
              </option>
              <option data-countrycode="SN" value="221">Senegal (+221)</option>
              <option data-countrycode="CS" value="381">Serbia (+381)</option>
              <option data-countrycode="SC" value="248">
                Seychelles (+248)
              </option>
              <option data-countrycode="SL" value="232">
                Sierra Leone (+232)
              </option>
              <option data-countrycode="SG" value="65">Singapore (+65)</option>
              <option data-countrycode="SK" value="421">
                Slovak Republic (+421)
              </option>
              <option data-countrycode="SI" value="386">Slovenia (+386)</option>
              <option data-countrycode="SB" value="677">
                Solomon Islands (+677)
              </option>
              <option data-countrycode="SO" value="252">Somalia (+252)</option>
              <option data-countrycode="ZA" value="27">
                South Africa (+27)
              </option>
              <option data-countrycode="ES" value="34">Spain (+34)</option>
              <option data-countrycode="LK" value="94">Sri Lanka (+94)</option>
              <option data-countrycode="SH" value="290">
                St. Helena (+290)
              </option>
              <option data-countrycode="KN" value="1869">
                St. Kitts (+1869)
              </option>
              <option data-countrycode="SC" value="1758">
                St. Lucia (+1758)
              </option>
              <option data-countrycode="SD" value="249">Sudan (+249)</option>
              <option data-countrycode="SR" value="597">Suriname (+597)</option>
              <option data-countrycode="SZ" value="268">
                Swaziland (+268)
              </option>
              <option data-countrycode="SE" value="46">Sweden (+46)</option>
              <option data-countrycode="CH" value="41">
                Switzerland (+41)
              </option>
              <option data-countrycode="SI" value="963">Syria (+963)</option>
              <option data-countrycode="TW" value="886">Taiwan (+886)</option>
              <option data-countrycode="TJ" value="7">Tajikstan (+7)</option>
              <option data-countrycode="TH" value="66">Thailand (+66)</option>
              <option data-countrycode="TG" value="228">Togo (+228)</option>
              <option data-countrycode="TO" value="676">Tonga (+676)</option>
              <option data-countrycode="TT" value="1868">
                Trinidad & Tobago (+1868)
              </option>
              <option data-countrycode="TN" value="216">Tunisia (+216)</option>
              <option data-countrycode="TR" value="90">Turkey (+90)</option>
              <option data-countrycode="TM" value="7">Turkmenistan (+7)</option>
              <option data-countrycode="TM" value="993">
                Turkmenistan (+993)
              </option>
              <option data-countrycode="TC" value="1649">
                Turks & Caicos Islands (+1649)
              </option>
              <option data-countrycode="TV" value="688">Tuvalu (+688)</option>
              <option data-countrycode="UG" value="256">Uganda (+256)</option>
              <option data-countrycode="GB" value="44">UK (+44)</option>
              <option data-countrycode="UA" value="380">Ukraine (+380)</option>
              <option data-countrycode="AE" value="971">
                United Arab Emirates (+971)
              </option>
              <option data-countrycode="UY" value="598">Uruguay (+598)</option>
              <option data-countrycode="US" value="1">USA (+1)</option>
              <option data-countrycode="UZ" value="7">Uzbekistan (+7)</option>
              <option data-countrycode="VU" value="678">Vanuatu (+678)</option>
              <option data-countrycode="VA" value="379">
                Vatican City (+379)
              </option>
              <option data-countrycode="VE" value="58">Venezuela (+58)</option>
              <option data-countrycode="VN" value="84">Vietnam (+84)</option>
              <option data-countrycode="VG" value="1284">
                Virgin Islands - British (+1284)
              </option>
              <option data-countrycode="VI" value="1340">
                Virgin Islands - US (+1340)
              </option>
              <option data-countrycode="WF" value="681">
                Wallis & Futuna (+681)
              </option>
              <option data-countrycode="YE" value="969">
                Yemen (North)(+969)
              </option>
              <option data-countrycode="YE" value="967">
                Yemen (South)(+967)
              </option>
              <option data-countrycode="ZM" value="260">Zambia (+260)</option>
              <option data-countrycode="ZW" value="263">Zimbabwe (+263)</option>
            </select>
          </div>
          <input
            type="text"
            id="city"
            class="form-control"
            :placeholder="$t('City12')"
            v-model="city"
            name="city"
          />
          <div class="phone-box">
            <input
              id="phone"
              type="tel"
              class="form-control"
              :placeholder="$t('TelephoneNum12')"
              v-model="phone"
              name="phone"
            />
          </div>
          <input
            type="tel"
            id="fax"
            class="form-control"
            :placeholder="$t('FaxNum12')"
            v-model="faxNumber"
            name="faxNumber"
          />
          <input
            type="text"
            id="website"
            class="form-control"
            :placeholder="$t('CompanyWeb12')"
            v-model="website"
            name="website"
          />
          <textarea
            class="form-control"
            id="comments"
            :placeholder="$t('Typehere12')"
            v-model="message"
            name="message"
          ></textarea>
        </div>
        <input
          type="submit"
          class="form-control"
          id="form_submit"
          :value="$t('Submit12')"
        />
      </form>
    </div>
    <div
      class="modal fade"
      id="contactModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="contactModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="contactModalLabel">
              {{ $t("ThankYou12") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <p>{{ $t("ReviewMsg12") }}</p>
            <p>{{ $t("SubmitMsg12") }}</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              id="close"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import emailjs from "emailjs-com";
const RecipientEmail = "UfaServerMail@gmail.com";

export default {
  name: "Contact_Us",
  data() {
    return {
      to_name: RecipientEmail,
      //Machinery: "",
      CompanyName: "",
      from_name: "",
      ContactPerson: "",
      Gender: "",
      Country: "",
      City: "",
      TelephomeNumber: "",
      FaxNumber: "",
      CompanyWebsite: "",
      TypeHere: "",
      reply_to: "",
    };
  },
  methods: {
    sendEmail() {
      try {
        var countryArr = [
          "",
          "Algeria",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antigua & Barbuda",
          "Argentina",
          "Armenia",
          "Aruba",
          "Australia",
          "Austria",
          "Azerbaijan",
          "Bahamas",
          "Bahrain",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "Belgium",
          "Belize",
          "Benin",
          "Bermuda",
          "Bhutan",
          "Bolivia",
          "Bosnia Herzegovina",
          "Botswana",
          "Brazil",
          "Brunei",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Cambodia",
          "Cameroon",
          "Canada",
          "Cape Verde Islands",
          "Cayman Islands",
          "Central African Republic",
          "Chile",
          "China",
          "Colombia",
          "Comoros",
          "Congo",
          "Cook Islands",
          "Costa Rica",
          "Croatia",
          "Cuba",
          "Cyprus North",
          "Cyprus South",
          "Czech Republic",
          "Denmark",
          "Djibouti",
          "Dominica",
          "Dominican Republic",
          "Ecuador",
          "Egypt",
          "El Salvador",
          "Equatorial Guinea",
          "Eritrea",
          "Estonia",
          "Ethiopia",
          "Falkland Islands",
          "Faroe Islands",
          "Fiji",
          "Finland",
          "France",
          "French Guiana",
          "French Polynesia",
          "Gabon",
          "Gambia",
          "Georgia",
          "Germany",
          "Ghana",
          "Gibraltar",
          "Greece",
          "Greenland",
          "Grenada",
          "Guadeloupe",
          "Guam",
          "Guatemala",
          "Guinea",
          "Guinea - Bissau",
          "Guyana",
          "Haiti",
          "Honduras",
          "Hong Kong",
          "Hungary",
          "Iceland",
          "India",
          "Indonesia",
          "Iran",
          "Iraq",
          "Ireland",
          "Israel",
          "Italy",
          "Jamaica",
          "Japan",
          "Jordan",
          "Kazakhstan",
          "Kenya",
          "Kiribati",
          "Korea North",
          "Korea South",
          "Kuwait",
          "Kyrgyzstan",
          "Laos",
          "Latvia",
          "Lebanon",
          "Lesotho",
          "Liberia",
          "Libya",
          "Liechtenstein",
          "Lithuania",
          "Luxembourg",
          "Macao",
          "Macedonia",
          "Madagascar",
          "Malawi",
          "Malaysia",
          "Maldives",
          "Mali",
          "Malta",
          "Marshall Islands",
          "Martinique",
          "Mauritania",
          "Mayotte",
          "Mexico",
          "Micronesia",
          "Moldova",
          "Monaco",
          "Mongolia",
          "Montserrat",
          "Morocco",
          "Mozambique",
          "Myanmar",
          "Namibia",
          "Nauru",
          "Nepal",
          "Netherlands",
          "New Caledonia",
          "New Zealand",
          "Nicaragua",
          "Niger",
          "Nigeria",
          "Niue",
          "Norfolk Islands",
          "Northern Marianas",
          "Norway",
          "Oman",
          "Pakistan",
          "Palau",
          "Panama",
          "Papua New Guinea",
          "Paraguay",
          "Peru",
          "Philippines",
          "Poland",
          "Portugal",
          "Puerto Rico",
          "Qatar",
          "Reunion",
          "Romania",
          "Russia",
          "Rwanda",
          "San Marino",
          "Sao Tome & Principe",
          "Saudi Arabia",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leone",
          "Singapore",
          "Slovak Republic",
          "Slovenia",
          "Solomon Islands",
          "Somalia",
          "South Africa",
          "Spain",
          "Sri Lanka",
          "St. Helena",
          "St. Kitts",
          "St. Lucia",
          "Sudan",
          "Suriname",
          "Swaziland",
          "Sweden",
          "Switzerland",
          "Syria",
          "Taiwan",
          "Tajikstan",
          "Thailand",
          "Togo",
          "Tonga",
          "Trinidad & Tobago",
          "Tunisia",
          "Turkey",
          "Turkmenistan",
          "Turkmenistan",
          "Turks & Caicos Islands",
          "Tuvalu",
          "Uganda",
          "UK",
          "Ukraine",
          "United Arab Emirates",
          "Uruguay",
          "USA",
          "Uzbekistan",
          "Vanuatu",
          "Vatican City",
          "Venezuela",
          "Vietnam",
          "Virgin Islands - British",
          "Virgin Islands - US",
          "Wallis & Futuna",
          "Yemen (North)",
          "Yemen (South)",
          "Zambia",
          "Zimbabwe",
        ];
        var templateParams = {
          to_name: RecipientEmail,
          //Machinery: this.Machinery,
          CompanyName: this.companyName,
          from_name: this.email,
          ContactPerson: this.Name,
          Gender: this.inquiryCategory,
          Country: countryArr[document.getElementById("country").selectedIndex],
          City: this.city,
          TelephomeNumber: "+" + this.country + "-" + this.phone,
          FaxNumber: "+" + this.country + "-" + this.faxNumber,
          CompanyWebsite: this.website,
          TypeHere: this.message,
          reply_to: "",
        };
        const serviceID = "service_d8wl523";
        const templateID = "template_7cr2dpu";
        const userID = "user_RxctHQohEyvfsiLoYKeNe";
        emailjs.send(serviceID, templateID, templateParams, userID);
        console.log("it works!!!");
      } catch (error) {
        console.log({ error });
      }
      function reloadContact() {
        window.location.reload();
      }
      window.setTimeout(function () {
        reloadContact();
      }, 3000);
    },
  },
};
</script>

<style scoped lang="stylus">
*, ::after, ::before
  box-sizing: border-box;

main
  overflow: visible;
  margin: 2em 0;
  text-align: left;

main img
  max-width:  100%
  margin-bottom:  1rem;

figcaption, figure, main
  display:  block;

hr
  overflow:visible;
  box-sizing:content-box;
  height:0;

.col-12,.col-md-11,.col-xl-6
  position: relative;
  width:  100%
  min-height: 1px;
  padding-right:  15px;
  padding-left: 15px;

.container .row
  position: relative;

.contact-us-box h2
  text-align: center;

.contact-us-box form
  margin:0 auto;
  padding:15px 30px;
  box-shadow:0 0 6px 0 #ccc;

.contact-us-box .hr-text:last-of-type
  margin-top:2rem;

.contact-us-box .hr-text
  position:relative;
  height:auto;
  width: auto;
  margin-top:0;
  margin-bottom:1rem;
  text-align:center;
  color:#013a6b;
  border:0;
  outline:0;

.contact-us-box .hr-text:before
  position:absolute;
  top:50%;
  left:0;
  width:100%;
  height:3px;
  content:'';
  background:linear-gradient(to right,transparent,#013a6b,transparent);

.contact-us-box .hr-text:after
  font-size:1.5rem;
  position:relative;
  display:inline-block;
  padding:0 .5em;
  content:attr(data-content);
  color:#013a6b;
  background:-webkit-linear-gradient(left, #fff, #969186, #fff);

.contact-us-box .problem-box div
  margin-bottom:  1rem;

.contact-us-box [data-tip]
  position:relative;
  transition:all .3s;
  opacity:0;

.contact-us-box [data-tip]:before
  font-size:0;
  line-height:0;
  position:absolute;
  z-index:8;
  top:-3px;
  left:35px;
  display:block;
  width:0;
  height:0;
  content:'';
  border-top:5px solid #1a1a1a;
  border-right:5px solid transparent;
  border-left:5px solid transparent;

.contact-us-box [data-tip]:after
  font-size:.75em;
  position:absolute;
  z-index:9;
  top:-30px;
  left:0;
  display:block;
  padding:5px 8px;
  content:attr(data-tip);
  white-space:nowrap;
  word-wrap:normal;
  color:#fff;
  border-radius:3px;
  background:#1a1a1a;

.contact-us-box .contact-info .form-control:first-of-type
  margin-top: 1rem;

.contact-us-box .contact-info .form-control
  margin-bottom:1rem;
  color:#013a6b;
  border-color:#5a6b8c;

.contact-us-box .problem-radio-box
  display:flex;
  margin-bottom:1rem;
  align-items:center;

.contact-us-box .problem-radio-box>div
  margin-right:20px;

.contact-us-box .select-box
  position:relative;

.contact-us-box .phone-box
  display:flex;
  margin-bottom:1rem;
  border:1px solid #5a6b8c;
  border-radius:.25rem;

.contact-us-box .phone-box .country-number
  font-size:14px;
  width:60px;
  padding:10px 5px;
  text-align:center;
  color:#013a6b;
  border:none;
  border-right:1px solid #5a6b8c;
  border-radius:.25em 0 0 .25em;
  background:#efefef;

.contact-us-box .phone-box #phone
  margin:0;
  border:none;

.contact-us-box .contact-info textarea
  height:150px;
  resize:none;
  color:#013a6b;
  border-color:#5a6b8c;

.contact-us-box input[type=submit]
  font-size:  20px;
  letter-spacing: 1px;
  color:  #fff;
  border: none;
  background-color: #013a6b;

.custom-control
  position: static;
  display:  block;
  min-height: 1.5rem;
  padding-left: 1.75rem;

.custom-control-input
    position:absolute;
    z-index:-1;
    margin-top: .2%;
    margin-left:  -2.5%;
    width:2%;
    height:2%;

.custom-checkbox .custom-control-input~.custom-control-label
  font-size:.875rem;
  cursor:pointer;

.custom-control-label
  position: relative;
  margin-bottom:  0;

.custom-control-label
  margin-bottom:  0;
  margin-left:  10px;

.custom-checkbox .custom-control-label::before
  border-radius:  .2rem;

.custom-control-label::before
  position:absolute;
  top:.125rem;
  left:-1.75rem;
  display:block;
  width:0px;
  height:0px;
  content:'';
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
  pointer-events:none;
  background-color:#fff;
  box-shadow:none;
  background-position:20% 50%;
  opacity:0;

.custom-control-label::after
  position:absolute;
  top:.125rem;
  left:-1.75rem;
  display:block;
  width:1.25rem;
  height:1.25rem;
  content:'';
  background-repeat:no-repeat;
  background-position:20% 50%;
  background-size:50% 50%;

.custom-control-label::before,.custom-file-label,.custom-select
  transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;

.custom-control-label::before
  transition: all .2s cubic-bezier(.68,-.55,.265,1.55);
  border: 1px solid #cad1d7;

.custom-radio .custom-control-label::before
  border-radius:50%;

.custom-radio .custom-control-input~.custom-control-label
  font-size:.875rem;
  cursor:pointer;

.h2, h2s
  font-size:  2rem;

h1, h2, h3, h4, h5, h6
  margin-top: 0;
  margin-bottom:  .5rem;

.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6
  font-family:  inherit;
  font-weight:  400;
  line-height:  1.5;
  margin-bottom:  .5rem;
  color:  #32325d;

.h5, h5
  font-size:  1.25rem;

input[type=checkbox], input[type=radio]
  box-sizing: border-box;
  padding:  0;

button, input, optgroup, select, textarea
  font-family:  DFKai-sb;
  font-size:  inherit;
  line-height:  inherit;
  margin: 0;

button
  border-radius:0;

button
  appearance:	auto;
  -webkit-writing-mode: horizontal-tb !important;
  text-rendering:auto;
  color:  -internal-light-dark(#000, #fff);
  letter-spacing:	normal;
  word-spacing:	normal;
  text-transform: none;
  text-indent:  0px;
  text-shadow:  none;
  display:  inline-block;
  text-align:	center;
  align-items:  flex-start;
  cursor:	default;
  background-color:	internal-light-dark(rgb(239, 239, 239), rgb(59,59,59));
  box-sizing:	border-box;
  margin:	0em;
  font: 400 13.3333px Arial;
  padding:	1px 6px;
  border-width:	2px;
  border-style:	outset;
  border-color:	-internal-light-dark(rgb(118,118,118),rgb(133,133,133));
  border-image:	initial;

button, select
  text-transform: none;

button, input
  overflow: visible;

button.close
  padding:  0;
  border: 0;
  background-color: transparent;
  -webkit-appearance: none;

.form-group
  margin-bottom:1rem;

[type=reset], [type=submit], button, html [type=button]
  -webkit-appearance: button;

.form-control
  font-size:  1rem;
  line-height:  1.5;
  display:  block;
  width:  100%;
  height: calc(2.75rem + 2px);
  padding:  .625rem .75rem;
  transition: all .2s cubic-bezier(.68,-.55,.265,1.55);
  color:  #8898aa;
  border: 1px solid #cad1d7;
  border-radius:  .25rem;
  background-color: #fff;
  background-clip:  padding-box;
  box-shadow: none;
  margin-top: 1rem;

.form-control
  font-size:  .875rem;

.mb-0, .my-0
  margin-bottom:  0.5%!important;

.mt-1,.my-1
  margin-top: .25%!important;

.ml-2, .mx-2
  margin-left:  9%!important;

.mr-3, .mx-3
  margin-right: 0%!important;

dl, ol, ul
  margin-top: 0;
  margin-bottom:  1rem;

ul
  padding:  0;
  list-style:none;

textarea.form-control
  height:auto;

textarea
  overflow:auto;
  resize:vertical;

.fade
  transition: opacity .15s  linear;

.modal
  position: fixed;
  z-index:  1050;
  top:  0;
  right:  0;
  bottom: 0;
  left: 0;
  display:  none;
  overflow: hidden;
  outline:0;

.fade:not(.show)
  opacity:0;

.modal-dialog
  position: relative;
  width:  auto;
  margin: .5rem;
  pointer-events: none;

.modal-dialog-centered
  display:  flex;
  min-height: calc(100% - (.5rem * 2));
  align-items:  center;

.modal-dialog
  max-width:  90%;

.modal.fade .modal-dialog
  transition: transition .3s ease-out;
  transform: translate(0, -25%);

.modal-dialog-centered::before
  display:  block;
  height: calc(100vh - (.5rem * 2));
  content:	'';

.modal-content
  position: relative;
  display:  flex;
  flex-direction: column;
  width:  100%;
  pointer-events: auto;
  border: 1px solid rgba(0,0,0,.2);
  border-radius:  .3rem;
  outline:  0;
  background-color: #fff;
  background-clip:  padding-box;
  box-shadow: 0 15px 35px rgb(50 50 93 / 20%), 0 5px 15px rgb(0 0 0 / 17%);

.modal-content
  border: 0;
  border-radius:  .3rem;

.modal-header
  display:  flex;
  padding:  1.25rem;
  border-bottom:  1px solid #e9ecef;
  border-top-left-radius: .3rem;
  border-top-right-radius:  .3rem;
  align-items:  flex-start;
  justify-content:  space-between;

.modal-title
  line-height:  1.1;
  margin-bottom:  0;

.close:not(:disabled):not(.disabled)
  cursor: pointer;

.modal-header .close
  margin: -1.25rem -1.25rem -1.25rem auto;
  padding:1.25rem;

.modal-body
  position:relative;
  padding:1.5rem;
  flex:1 1 auto;

.modal-dialog .modal-body
  height: 100%;
  text-align: center;

.modal-footer
  display:flex;
  padding:1.5rem;
  border-top:1px solid #e9ecef;
  align-items:center;
  justify-content:flex-end;

.close
  font-size:  1.5rem;
  font-weight:  600;
  line-height:  1;
  float:  right;
  opacity:  .5;
  color:  rgba(0,0,0,.6);
  text-shadow:  none;

.close
  transition: all .15s ease;

.close
  position: absolute;
  top:  15px;
  right:  35px;
  color:  #f1f1f1;
  font-size:  40px;
  font-weight:  bold;
  transition: .3s;

.close>span:not(.sr-only)
  font-size:  1.25rem;
  line-height:  17px;
  display:  block;
  width:  1.25rem;
  height: 1.25rem;
  transition: all .15s ease;
  color:  rgba(0, 0, 0, .6);
  border-radius:  50%;
  background-color: transparent;

.btn:not(:disabled):not(.disabled)
  cursor: pointer;

.btn
  font-size:  .875rem;
  font-weight:  600;
  line-height:  1.5;
  display:  inline-block;
  padding:  .625rem 1.25rem;
  -webkit-user-select:  none;
  -moz-user-select: none;
  -ms-user-select:  none;
  user-select:  none;
  transition: color .15s ease-in-out, background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out
  text-align: center;
  vertical-align: middle;
  white-space:  nowrap;
  border: 1px solid transparent;
  border-radius:  .25rem;

.btn-secondary
  color:#212529;
  border-color:#f4f5f7;
  background-color:#f4f5f7;
  box-shadow:0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);

.btn
  font-size:  .875rem;
  position: relative;
  transition: all .15s ease;
  letter-spacing: .025em;
  text-transform: uppercase;
  will-change:  transform;

.loader
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius:  50%;
  width:  120px;
  height: 120px;
  animation:  spin 2s linear infinite;

@keyframes spin
  0%
    transform:  rotate(0deg);
  100%
    transform:  rotate(360deg);
</style>
